import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");


export const fetchRegion = createAsyncThunk(
    "client/fetchRegion",
    async (_, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}region`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);

export const fetchState = createAsyncThunk(
    "client/fetchState",
    async ({id}, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}region/state/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch state." });
        }
    }
);
export const fetchAllState = createAsyncThunk(
    "client/fetchAllState",
    async (_, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}state`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch states." });
        }
    }
);

export const fetchCity = createAsyncThunk(
    "client/fetchCity",
    async (_, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}city`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch city." });
        }
    }
);
export const fetchClient = createAsyncThunk(
    "client/fetchClient",
    async ({search,state,region,channel,role,from,to,page,rowsPerPage,sort_by,sort_order,month,year,filterByClientCreatedAt}, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const roleParam = role && role.length > 0 ? `&role=${role.join(',')}` : '';
            const channelParam = channel && channel.length > 0 ? `&channel=${channel.join(',')}` : '';
            const response = await axios.get(`${Apiurl}admin/userlist/client?search=${search}&state=${state}&region=${region}${roleParam}${channelParam}&page=${page+1}&limit=${rowsPerPage}&from=${from}&to=${to}&sort_by=${sort_by}&sort_order=${sort_order}&month=${month}&year=${year}&filterByClientCreatedAt=${filterByClientCreatedAt || false}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);
export const fetchUserClient = createAsyncThunk(
    "client/fetchUserClient",
    async ({search,page,rowsPerPage}, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}client?search=${search}&page=${page+1}&limit=${rowsPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);
export const fetchUserClientOption = createAsyncThunk(
    "client/fetchUserClientoption",
    async (_, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}client/clients`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);

export const fetchUserOption = createAsyncThunk(
    "client/fetchUseroption",
    async (_, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/userlist/users`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);
export const fetchUsers = createAsyncThunk(
    "client/fetchUser",
    async ({search,state,region,channel,from,to,page,rowsPerPage,sort_by,sort_order,role,month,year, status, showLiveUsers}, { rejectWithValue }) => {

        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });

        try {
            const response = await axios.get(`${Apiurl}admin/userlist?search=${search}&state=${state}&region=${region}&channel=${channel || ''}&page=${page+1}&limit=${rowsPerPage}&from=${from}&to=${to}&sort_by=${sort_by}&sort_order=${sort_order}&role=${role}&month=${month}&year=${year}&status=${status}&showLiveUsers=${showLiveUsers}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);

const initialState = {
    regionData: [],
    stateData: [],
    allStateData: [],
    cityData: [],
    userOpt: [],
    userOption: [],
    clientDatas: [],
    clientsOption: [],
    userClientsData: [],
    count: 0,
    loading: false,
    getStatus: "idle",
    status: "idle",
    deleteStatus: "idle",
    error: null,
};

const clientSlice = createSlice({
    name: "client",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRegion.pending, (state) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchRegion.fulfilled, (state, action) => {
                state.regionData = action.payload.data;
                state.getStatus = "succeeded";
            })
            .addCase(fetchRegion.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(fetchState.pending, (state) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchState.fulfilled, (state, action) => {
                state.stateData = action.payload.data;
                state.getStatus = "succeeded";
            })
            .addCase(fetchState.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(fetchAllState.pending, (state) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchAllState.fulfilled, (state, action) => {
                state.allStateData = action.payload;
                state.getStatus = "succeeded";
            })
            .addCase(fetchAllState.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(fetchCity.pending, (state) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchCity.fulfilled, (state, action) => {
                state.cityData = action.payload;
                state.getStatus = "succeeded";
            })
            .addCase(fetchCity.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(fetchClient.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase(fetchClient.fulfilled, (state, action) => {
                state.clientDatas = action.payload.data;
                state.count = action.payload.total;
                state.status = "succeeded";
            })
            .addCase(fetchClient.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            })
            .addCase(fetchUserClient.pending, (state) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchUserClient.fulfilled, (state, action) => {
                state.userClientsData = action.payload.data;
                state.count = action.payload.total;
                state.getStatus = "succeeded";
            })
            .addCase(fetchUserClient.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(fetchUserClientOption.pending, (state) => {
                state.error = null;
                state.getStatus = "pending";
            })
            .addCase(fetchUserClientOption.fulfilled, (state, action) => {
                state.clientsOption = action.payload.data;
                state.getStatus = "succeeded";
            })
            .addCase(fetchUserClientOption.rejected, (state, action) => {
                state.error = action.payload;
                state.getStatus = "failed";
            })
            .addCase(fetchUsers.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.userOpt = action.payload.data.data;
                state.count = action.payload.total;
                state.status = "succeeded";
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            })
            .addCase(fetchUserOption.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase(fetchUserOption.fulfilled, (state, action) => {
                state.userOption = action.payload.data?.filter(u=>u.name?.toLowerCase() !=='admin');
                state.status = "succeeded";
            })
            .addCase(fetchUserOption.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            })
    },
});

export default clientSlice.reducer;
